import * as palette from "../palette";

import PropTypes from "prop-types";
import React from "react";

export default function ToolbarToggleButton({ isActive, children, ...props }) {
  return (
    <div
      css={{
        cursor: "pointer",
        color: isActive ? palette.darkSkyBlue : "#ffffff",
        userSelect: "none",

        boxSizing: "border-box",

        width: 30,
        height: 30,

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      {children}
    </div>
  );
}

ToolbarToggleButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
};
